import { Component } from '@angular/core';
import { BaseComponent } from '@ids-components';
import { SharedNetworkFormComponent } from '../../../../shared-components/shared-network-form/shared-network-form.component';
import { CommonLayoutComponent } from '@microsec/components';
import { SharedLicenseWarningComponent } from '@ids-products';
import { NetworkListComponent } from './network-list/network-list.component';

@Component({
  selector: 'app-networks',
  templateUrl: './networks.component.html',
  styleUrls: ['./networks.component.scss'],
  imports: [CommonLayoutComponent, SharedNetworkFormComponent, SharedLicenseWarningComponent, NetworkListComponent],
})
export class NetworksComponent extends BaseComponent {
  form = {
    visible: false,
    connection: null,
  };

  openConnectionForm(connection?: any) {
    this.form = {
      visible: true,
      connection: connection || null,
    };
  }

  closeConnectionForm() {
    this.form = {
      visible: false,
      connection: null,
    };
  }
}
